module.exports = __webpack_public_path__ + "static/media/ATCLogo_Small.993b4715.png";